import { AuthServiceConfig, FacebookLoginProvider } from 'angular5-social-login';

export function getAuthServiceConfigs() {
    const config = new AuthServiceConfig([
        {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider('2395299290689343')
        }
    ]);

    return config;
}



// WEBPACK FOOTER //
// ./src/sociallogin.config.ts